<p-tag
  [rounded]="roundedCorners"
  [style]="{
    color: textColor,
    'background-color': backgroundColor,
    'border-color': borderColor,
    padding: tagInnerPadding
  }"
  [ngClass]="customClass"
  [styleClass]="'severity-'+severityClass + ' ' + 'style-'+styleClass + ' ' + sizeClass + ' ' + customStyleClass + ' ' + widthClass()"
>
<div tag-content p-template="content" class="flex align-items-center justify-content-center gap-spacing-default">
  @if (iconStart) {
    <i [class]="iconStart + ' p-tag-icon me-0'"></i>
  }
  {{displayContent ? content || emptyContentPlaceholder : ''}}
  @if (iconEnd) {
    <i [class]="iconEnd + ' p-tag-icon me-0'"></i>
  }
</div>
</p-tag>
